// ============================================================================
// About page — team modal + video click-to-play
// ---------------------------------------------------------------------------
// Pure DOM behaviors (not animations). Replaces the three inline scripts
// that lived on the team section, the modal container, and the close button.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  setupTeamModal();
  setupValueVideoClickToPlay();
});

// ----------------------------------------------------------------------------
// Team modal
// ----------------------------------------------------------------------------
function setupTeamModal() {
  const modalContainer = document.querySelector(
    ".page-about--team-modal--container",
  );
  if (!modalContainer) return;

  const modalWrap = document.querySelector(".page-about--team-modal--wrap");
  const modalTitle = document.querySelector(".page-about--team-modal--title");
  const modalName = document.querySelector(".page-about--team-modal--name");
  const modalBio = document.querySelector(".page-about--team-modal--bio");
  const modalImg = document.querySelector(".page-about--team-modal--img");

  const htmlEl = document.documentElement;
  const bodyEl = document.body;

  function openModal(card) {
    modalContainer.classList.add("open");

    if (modalTitle) modalTitle.innerText = card.getAttribute("title") || "";
    if (modalName) modalName.innerText = card.getAttribute("name") || "";
    if (modalBio) modalBio.innerHTML = card.getAttribute("bio") || "";
    if (modalImg) modalImg.src = card.getAttribute("img") || "#";

    htmlEl.style.overflowY = "hidden";
    bodyEl.style.overflowY = "hidden";

    // Reset the modal scroll position after the layout settles.
    setTimeout(function () {
      if (modalWrap) modalWrap.scrollTop = 0;
    }, 100);
  }

  function closeModal() {
    modalContainer.classList.remove("open");
    htmlEl.style.overflowY = "";
    bodyEl.style.overflowY = "";
  }

  // Open: clicking any team card
  document
    .querySelectorAll(".page-about--team-card--item")
    .forEach(function (card) {
      card.addEventListener("click", function () {
        openModal(card);
      });
    });

  // Close: clicking the backdrop (not the modal content itself)
  modalContainer.addEventListener("click", function (e) {
    if (e.target === modalContainer) {
      closeModal();
    }
  });

  // Close: clicking the Close button inside the modal (#div_block-174-1198)
  const closeButton = document.querySelector("#div_block-174-1198");
  if (closeButton) {
    closeButton.addEventListener("click", closeModal);
  }

  // Close: Esc key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modalContainer.classList.contains("open")) {
      closeModal();
    }
  });
}

// ----------------------------------------------------------------------------
// Values section — click-to-play overlay button over the video
// ----------------------------------------------------------------------------
function setupValueVideoClickToPlay() {
  const playButton = document.querySelector("#div_block-52-1198");
  const videoEl = document.querySelector("#code_block-50-1198");
  if (!playButton || !videoEl) return;

  playButton.addEventListener("click", function () {
    playButton.style.display = "none";
    const attempt = videoEl.play();
    if (attempt && typeof attempt.catch === "function") {
      attempt.catch(function () {});
    }
  });
}
